<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-2 mt-md-0">
        <app-list-header
          [title]="'Task.Task_List' | translate"
          icon="bi bi-check2-circle"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>

    <div class="col-md-12 col-xl-8">
      <div class="row">
        <div class="col-lg-12 mb-3">
          <div class="card shadow-sm border-0">
            <div class="card-body p-3 p-md-4 pb-md-0">
              <div
                class="row g-2 align-items-center mb-3 compact-inputs dropdown-pd-none"
              >
                <!-- Title Search -->
                <div class="col-md-6 px-1">
                  <div class="d-flex align-items-center">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{
                        "Task.Enter_title" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.searchParams['title']"
                        id="title"
                        name="title"
                      />
                    </mat-form-field>
                    <button
                      mat-icon-button
                      type="button"
                      class="icon-center icon-clean ms-1"
                      matTooltip="Enter title"
                      matTooltipPosition="above"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>

                <!-- Target Date Search -->
                <div class="col-md-6 px-1">
                  <div class="d-flex align-items-center">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{
                        "Task.Target_Date" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.searchParams['targetDate']"
                        id="targetDate"
                        name="targetDate"
                        type="date"
                        #dashDate
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        (click)="dashDate.showPicker()"
                        type="button"
                        class="icon-pd-none"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >calendar_today</mat-icon
                        >
                      </button>
                    </mat-form-field>
                    <button
                      mat-icon-button
                      type="button"
                      class="icon-center icon-clean ms-1"
                      matTooltip="Select Date"
                      matTooltipPosition="above"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>

                <!-- Priority Filter -->
                <div class="col-auto px-1">
                  <button
                    mat-stroked-button
                    type="button"
                    (click)="searchPriority()"
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'High Priority'"
                    matTooltipPosition="above"
                  >
                    <i
                      class="fa fa-star"
                      [style.color]="
                        form.searchParams['priority'] === 'High'
                          ? '#ffc107'
                          : '#ccc'
                      "
                      [class.checked]="form.searchParams['priority'] === 'High'"
                    ></i>
                  </button>
                </div>

                <!-- Completed Filter -->
                <div class="col-auto">
                  <button
                    mat-stroked-button
                    type="button"
                    (click)="searchComplete()"
                    [color]="
                      form.searchParams['status'] === 'Complete'
                        ? 'primary'
                        : ''
                    "
                    [class.search-btn-marked]="
                      form.searchParams['status'] === 'Complete'
                    "
                  >
                    {{ "Task.Completed" | translate }}
                  </button>
                </div>

                <!-- Not Started Filter -->
                <div class="col-auto">
                  <button
                    mat-stroked-button
                    type="button"
                    (click)="searchNotStarted()"
                    [color]="
                      form.searchParams['status'] === 'Not started'
                        ? 'primary'
                        : ''
                    "
                    [class.search-btn-marked]="
                      form.searchParams['status'] === 'Not started'
                    "
                  >
                    {{ "Task.Not_Started" | translate }}
                  </button>
                </div>

                <!-- Search Button -->
                <div class="col-auto">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="search()"
                  >
                    <mat-icon>search</mat-icon> {{ "Task.Search" | translate }}
                  </button>
                </div>

                <!-- Reset Button -->
                <div class="col-auto">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="resetSearchForm()"
                  >
                    <i class="fa fa-eraser"></i>
                    <span class="ms-2">{{ "COMMON.RESET" | translate }}</span>
                  </button>
                </div>

                <!-- Add Button -->
                <div class="col-auto">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="get(0)"
                  >
                    <mat-icon>add</mat-icon> {{ "Task.Add" | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Task List Display -->
            <div class="card-body p-0 my-2">
              <div class="col-12 px-3">
                <!-- Alert Messages -->
                <div *ngIf="form['searchMessage']" class="mb-3">
                  <div
                    [class]="
                      form['searchError']
                        ? 'alert alert-danger shadow-sm border-0'
                        : 'alert alert-success shadow-sm border-0'
                    "
                  >
                    <i
                      [class]="
                        form['searchError']
                          ? 'bi bi-exclamation-octagon me-2'
                          : 'bi bi-check2-circle me-2'
                      "
                    ></i>
                    {{ form["searchMessage"] }}
                  </div>
                </div>

                <!-- Task Cards -->
                <div class="rounded-3 shadow-sm overflow-hidden">
                  <div
                    *ngFor="let e of form.list; let i = index"
                    [ngClass]="getBackgroundClass(e.status, e.targetDate)"
                    class="p-3 border-bottom list-item-hover"
                    style="margin-bottom: 1px"
                  >
                    <div class="row g-3">
                      <!-- Status and Priority Icons -->
                      <div class="col-md-auto col-12 d-flex align-items-center">
                        <div class="col-auto d-flex align-items-center gap-2">
                          <div
                            (click)="changeStatus(e.id, 'Completed')"
                            class="cursor-pointer"
                          >
                            <i
                              *ngIf="
                                e['status'] === 'Not started' || !e['status']
                              "
                              class="bi bi-circle fs-5 text-muted"
                            ></i>
                            <i
                              *ngIf="e['status'] === 'Completed'"
                              class="bi bi-check-circle-fill fs-5 text-success"
                            ></i>
                          </div>
                          <div
                            (click)="changePriority(e['id'], e['priority'])"
                            class="cursor-pointer"
                          >
                            <i
                              class="fa fa-star fs-5"
                              [class.text-warning]="e['priority'] === 'High'"
                              [class.text-light]="e['priority'] !== 'High'"
                            ></i>
                          </div>
                        </div>
                      </div>

                      <!-- Task Details -->
                      <div class="col-md-auto col-12">
                        <div
                          class="fw-bold mb-0"
                          [ngClass]="
                            e.status === 'Completed'
                              ? 'task-completed-text'
                              : 'default'
                          "
                        >
                          {{ pageIndex(i) }}. {{ e.title }}
                        </div>
                        <div
                          class="text-muted small my-2 text-wrap text-break cursor-help"
                          [title]="e['description']"
                          matTooltipClass="custom-tooltip-multiline"
                        >
                          <span class="fw-bold text-secondary"
                            >{{ "Task.Description" | translate }}:</span
                          >
                          {{ e["description"] | truncate: 80 }}
                        </div>

                        <div class="d-flex flex-wrap gap-2">
                          <small
                            class="text-secondary d-flex align-items-center"
                          >
                            <i class="bi bi-calendar-check me-1"></i>
                            <strong
                              >{{ "Task.Target_Date" | translate }}:</strong
                            >
                            &nbsp;
                            {{
                              e.targetDate
                                ? (e.targetDate | date: "dd/MM/yyyy")
                                : "N/A"
                            }}
                            {{ transform(e.targetTime) }}
                          </small>

                          <small
                            *ngIf="e.completionDate"
                            class="completion-text d-flex align-items-center flex-wrap"
                          >
                            <i class="bi bi-flag-fill me-1 completion-text"></i>
                            <strong>{{ "Task.Completed" | translate }}:</strong>
                            &nbsp;
                            {{ e.completionDate | date: "dd/MM/yyyy hh:mm a" }}
                          </small>
                        </div>
                      </div>

                      <!-- Action Buttons -->
                      <div class="col-md-auto col-12 ms-md-auto">
                        <div class="d-flex gap-2 align-items-center">
                          <button
                            mat-stroked-button
                            class="icon-center icon-width"
                            color="primary"
                            (click)="get(e.id)"
                            *ngIf="e['status'] !== 'Completed'"
                            matTooltip="{{
                              'ADD_ROLE_APP.BUTTONS.EDIT' | translate
                            }}"
                            matTooltipPosition="above"
                          >
                            <mat-icon>edit</mat-icon>
                          </button>

                          <button
                            mat-stroked-button
                            class="icon-center icon-width"
                            color="warn"
                            (click)="delete(e.id)"
                            matTooltip="{{ 'COMMON.DELETE' | translate }}"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="icon-compact">delete</mat-icon>
                          </button>

                          <button
                            mat-stroked-button
                            class="icon-center icon-width"
                            [matTooltip]="'Status: ' + (e.status || 'Pending')"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="text-secondary">info</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side Form Panel -->
    <div class="col-md-12 col-xl-4 mb-2">
      <div
        class="card shadow-sm border-0 compact-inputs position-sticky sticky-xl-top"
        style="top: 4.5rem; z-index: 0; overflow-y: visible"
      >
        <h6 class="card-header mb-0 cardheader-title">
          {{ "Task.Task" | translate }}
        </h6>
        <div class="card-body p-3 p-md-4">
          <!-- Alert Messages -->
          <div class="mb-3">
            <app-ncs-alert
              *ngIf="form['message'] && form['error'] == false"
              [message]="form['message']"
              type="success"
            ></app-ncs-alert>
            <app-ncs-alert
              *ngIf="form['message'] && form['error'] == true"
              [message]="form['message']"
              type="danger"
            ></app-ncs-alert>
          </div>

          <!-- Task Form -->
          <form #uiForm="ngForm">
            <div class="row g-3">
              <!-- Title -->
              <div class="col-12 mb-3">
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="dynamic"
                  class="w-100"
                >
                  <mat-label>{{ "Task.Title" | translate }}</mat-label>
                  <input
                    matInput
                    required
                    [(ngModel)]="form.data['title']"
                    name="title"
                  />
                </mat-form-field>
              </div>

              <!-- Description -->
              <div class="col-12 mb-3 textarea-container">
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="dynamic"
                  class="w-100"
                >
                  <mat-label>{{ "Task.Description" | translate }}</mat-label>
                  <textarea
                    matInput
                    required
                    [(ngModel)]="form.data['description']"
                    name="description"
                    rows="3"
                  ></textarea>
                </mat-form-field>
              </div>

              <!-- Target Date -->
              <div class="col-12 mb-3">
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="dynamic"
                  class="w-100"
                >
                  <mat-label>{{ "Task.Target_Date" | translate }}</mat-label>
                  <input
                    matInput
                    [(ngModel)]="form.data['targetDate']"
                    name="targetDate"
                    type="date"
                    #targetDatePicker
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="targetDatePicker.showPicker()"
                    class="icon-pd-none"
                    type="button"
                  >
                    <mat-icon class="icon-compact text-secondary"
                      >calendar_today</mat-icon
                    >
                  </button>
                </mat-form-field>
              </div>

              <!-- Target Time -->
              <div class="col-12 mb-3">
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="dynamic"
                  class="w-100"
                >
                  <mat-label>{{ "Task.Target_Time" | translate }}</mat-label>
                  <input
                    matInput
                    [(ngModel)]="form.data['targetTime']"
                    name="targetTime"
                    type="time"
                    #targetTimePicker
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="targetTimePicker.showPicker()"
                    class="icon-pd-none"
                    type="button"
                  >
                    <mat-icon class="icon-compact text-secondary"
                      >schedule</mat-icon
                    >
                  </button>
                </mat-form-field>
              </div>
            </div>

            <!-- Form Actions -->
            <div class="d-flex flex-column mt-3 gap-2">
              <button
                mat-flat-button
                color="primary"
                *ngIf="form.data['status'] != 'Completed'"
                [disabled]="!uiForm.valid"
                (click)="save()"
              >
                <mat-icon>save</mat-icon>
                <span class="ms-1">{{ "Task.Save" | translate }}</span>
              </button>
              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="resetForm()"
              >
                <mat-icon>add</mat-icon>
                <span class="ms-1">{{ "Task.New" | translate }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="col-12 mb-3">
      <app-list-header [$parent]="getSelf()"></app-list-header>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade modal-dialog-scrollable"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalLabel">
          {{ "Task.Task" | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'Task.Close' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <form class="form-horizontal" role="form" #uiForm="ngForm">
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>

          <div class="mb-3">
            <label for="title" class="col col-form-label col-form-label-sm">
              {{ "Task.Title" | translate }}:
            </label>
            <div class="col">
              <input
                required
                [(ngModel)]="form.data['title']"
                id="title"
                name="title"
                [placeholder]="'Task.Enter_Title' | translate"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
          </div>

          <div class="mb-3">
            <label
              for="description"
              class="col col-form-label col-form-label-sm"
            >
              {{ "Task.Description" | translate }}:
            </label>
            <div class="col">
              <textarea
                required
                [(ngModel)]="form.data['description']"
                id="description"
                name="description"
                [placeholder]="'Task.Enter_description' | translate"
                type="text"
                class="form-control form-control-sm"
              >
              </textarea>
            </div>
          </div>
          &nbsp;

          <div class="mb-3">
            <label
              for="targetDate"
              class="col col-form-label col-form-label-sm"
            >
              {{ "Task.Target_Date" | translate }}:
            </label>
            <div class="row">
              <div class="col">
                <input
                  [(ngModel)]="form.data['targetDate']"
                  id="targetDate"
                  name="targetDate"
                  [placeholder]="'Task.Enter_TargetDate' | translate"
                  type="date"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="col">
                <input
                  [(ngModel)]="form.data['targetTime']"
                  id="targetTime"
                  name="targetTime"
                  [placeholder]="'Task.Enter_targetTime' | translate"
                  type="time"
                  class="form-control form-control-sm"
                />
              </div>
            </div>
          </div>
          &nbsp;
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          [disabled]="!uiForm.valid"
          (click)="save()"
        >
          <i class="fa fa-save"></i> {{ "Task.Save" | translate }}
        </button>
        &nbsp;
        <button
          class="btn btn-outline-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i>
          {{ "Task.Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>